import React from "react";

function Adopt() {
  return (
    <section id="adopt" className="adopt">
      <div className="container">
        <h2>Adopt or Foster an Animal</h2>
        <p>
          Every pet deserves a loving home, and you have the power to change a
          life. By adopting, you provide a homeless pet with safety, care, and a
          forever family. If you're not ready for long-term commitment,
          fostering is a wonderful way to help. Foster homes give rescued
          animals temporary care, socialization, and a chance to heal while
          waiting for adoption. Many shelters are overcrowded, and fostering
          helps free up space, allowing more animals to be saved.
        </p>
        <p>
          Your actions, whether adopting or fostering, create a lasting impact.
          You’re not only saving one life but also making room for another pet
          in need. These animals are filled with love, loyalty, and gratitude,
          just waiting for a second chance. If you can’t adopt or foster,
          consider supporting by spreading awareness or donating. Join us
          today—because every small act of kindness makes a world of difference
          to an animal in need.
        </p>
        <div className="cta-buttons">
          <a
            href="https://expo.dev/accounts/abhaykeshri/projects/rehome/builds/51e0ce25-9131-45cb-9b6c-f334b3cf0205"
            className="btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            Adopt Now
          </a>
          <a
            href="https://expo.dev/accounts/abhaykeshri/projects/rehome/builds/51e0ce25-9131-45cb-9b6c-f334b3cf0205"
            className="btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            Foster a Pet
          </a>
        </div>
        <div className="videos">
          <h3>Learn More About Adoption & Fostering</h3>
          <div className="video-list">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/gD1Qe5Czq60"
              title="Why Adopt a Pet?"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/ChAkWW5pW_g"
              title="How to Foster a Pet?"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
      <style jsx>{`
        .video-list {
          display: flex;
          flex-direction: row; /* Makes videos appear side by side */
          gap: 20px; /* Adds space between the videos */
          justify-content: center; /* Centers the videos horizontally */
          flex-wrap: wrap; /* Ensures responsiveness on smaller screens */
        }
      `}</style>
    </section>
  );
}

export default Adopt;
